import React from 'react'
import './normalize.css'
import './fonts.css'
import './base.css'
import Header from './header'
import Footer from './footer';

class Template extends React.Component {
  render() {
    const { children } = this.props

    return (
      <div className="layout">
        <Header for={this.props.for}/>
        {children}
        <div className="spacer"/>
        <Footer/>
      </div>
    )
  }
}

export default Template
